import DynamicIcon, { IconName } from '@/components/DynamicIcon'
import { badgeColorMap } from '@/utilities/badgeColorMap'
import { kebabToCamel } from '@/utilities/toCamel'
import { cn } from '@/utilities/ui'

import type { Topic } from '@/payload-types'

export const CategoryIcons = ({
  size = 'default',
  allTopics,
  specificTopics,
}: {
  size?: 'small' | 'default'
  allTopics: Topic[]
  specificTopics: Topic[]
}) => {
  if (specificTopics.length === 0) return null

  const firstTwoTopics = specificTopics.slice(0, 2)

  return firstTwoTopics.length > 0 ? (
    <div className={cn('flex items-center gap-2', 'relative right-5')}>
      {firstTwoTopics?.map((category) => {
        const categoryData = allTopics.find((c) => c.title === (category as Topic).title)
        if (!categoryData) return null

        const topicColor = kebabToCamel(categoryData.color || 'tuscany')

        return (
          <span
            key={(category as Topic).id}
            className={cn(
              'flex items-center justify-center',
              'size-8 rounded-xl',
              badgeColorMap[topicColor].bg,
              badgeColorMap[topicColor].text,
              'transition-transform hover:scale-105',
              size === 'small' && 'rounded-t-none',
            )}
            title={(category as Topic).title}
          >
            <DynamicIcon name={categoryData.icon as IconName} className="size-4" />
          </span>
        )
      })}
    </div>
  ) : null
}
